export default "<app-header></app-header>\n\n<div style=\"padding: 25px;\"></div>\n\n<router-outlet></router-outlet>\n\n<app-footer></app-footer>"